import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from 'react-router';

import CustomSelect from '@/views/components/CustomSelect/CustomSelect';

import queryString from 'query-string';
import api from '@/services/api';
import parseObjectToQuery from '@/utils/functions/parseObjectToQuery';

const LettersDeptAutoSuggest = ({
	label,
	placeholder,
	tooltipIcon = null,
	onChangeCallback = null,
	startDepartmentId = null,
	formInput = false,
	controlURL = true,
	param = null,
}) => {
	const [ value, setValue ] = useState();
	const [ suggestions, setSuggestions ] = useState([]);
	const [ selectedDepartment, setSelectedDepartment ] = useState();

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		let fetchDepartmentId = null;
		if (startDepartmentId) fetchDepartmentId = startDepartmentId;
		const locationDepartment = new URLSearchParams(location.search).get('department');
		if (!startDepartmentId && locationDepartment){
			fetchDepartmentId = locationDepartment;
		}

		setSelectedDepartment(fetchDepartmentId);

		api.get(`/autocomplete/departments?q=`)
			.then(response => {
				setSuggestions(getSuggestions(response.data));
			});
	}, []);

	useEffect(() => {
		const found = suggestions.find((val) => { return val.value == selectedDepartment; });

		if (found) {
			setValue(found);
		}
	}, [ suggestions, selectedDepartment ]);

	useEffect(() => {
		if (controlURL && suggestions.length > 0) {
			const qu = queryString.parse(location.search);

			const found = suggestions.find((val) => { return val.value == qu.department; });

			if (qu.department) {
				setValue(found);
			} else {
				setValue("");
			}
		}
	}, [ location, suggestions ]);

	useEffect(() => {
		setSelectedDepartment(startDepartmentId);
	}, [ startDepartmentId ]);

	const getSuggestions = (array) => {
		return array.map((item) => {
			return { value: item.id, label: item.name };
		});
	};

	const handleChangeDept = (item) => {
		if(sessionStorage.getItem('firstLoginDefaultDepartment')) {
			sessionStorage.removeItem('firstLoginDefaultDepartment');
		}
		if(item){
			setValue(item);
			if (onChangeCallback && !param) { onChangeCallback(item.value); }
			else if (onChangeCallback && param) { onChangeCallback(item[`${param}`]); }
			const qu = queryString.parse(location.search);
			if (controlURL) return navigate(`${location.pathname}?${parseObjectToQuery({ ...qu, department: item.value })}`);
		} else {
			if (!controlURL) return;
			setValue(item);
			const qu = queryString.parse(location.search);
			if (onChangeCallback) { onChangeCallback(null); }
			if (Object.keys(qu).indexOf('department') !== -1) {
				delete qu.department;
				navigate(`${location.pathname}?${parseObjectToQuery(qu)}`);
			}
		}
	};

	return (
		<CustomSelect
			isClearable={ !formInput }
			label={ label }
			placeholder={ placeholder }
			tooltipText={ tooltipIcon }
			value={ value }
			options={ suggestions }
			formInput={ formInput }
			onChange={ handleChangeDept }
		/>
	);
};

export default LettersDeptAutoSuggest;
